import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Drawer } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { CustomPoiEditForm, CustomPoiFormData } from './CustomPoiEditForm';
import { getLocationTypes, getSelectedCustomPoi } from '../../../redux/selectors/poiAdmin';
import { getLocationTypeDisplayName } from '../../../util/poi';

interface ComponentProps extends FormComponentProps {
  onClose: () => void;
}

const CustomPoiDrawer = ({ onClose, form }: ComponentProps) => {
  const locationTypes = useSelector(getLocationTypes);
  const selectedCustomPoi = useSelector(getSelectedCustomPoi);

  const [formData, setFormData] = useState<CustomPoiFormData | null>(null);

  useEffect(() => {
    if (locationTypes && selectedCustomPoi) {
      const locationType = locationTypes.find(type => type.id === selectedCustomPoi.locationTypeId);
      const locationTypeDisplayName = locationType
        ? getLocationTypeDisplayName(locationType)
        : 'unknown';

      setFormData({
        locationId: selectedCustomPoi.locationId,
        code: selectedCustomPoi.code,
        name: selectedCustomPoi.name,
        type: locationTypeDisplayName,
        latitude: selectedCustomPoi.latitude,
        longitude: selectedCustomPoi.longitude,
        organisationId: selectedCustomPoi.organisationId,
        locationTypes: locationTypes
      });
    }
  }, [locationTypes, selectedCustomPoi]);

  return (
    <Drawer
      data-testid={'custom-poi-edit-drawer'}
      title="Edit"
      placement="right"
      onClose={onClose}
      visible={true}
      width={400}
    >
      <div style={{ paddingTop: '2em', width: '85%', marginLeft: '2em', marginRight: '2em' }}>
        <CustomPoiEditForm initialData={formData} onClose={onClose} form={form} />
      </div>
    </Drawer>
  );
};

export default Form.create<ComponentProps>()(CustomPoiDrawer);
